import React, { useEffect, useMemo, useState } from "react";
import Ordercards from "./Ordercards";
import order from "../../assets/images/svgs/cards/orders.svg";
import delivery from "../../assets/images/svgs/cards/delivery.svg";
import { GoMoon, GoSun } from "react-icons/go";
import { useDispatch, useSelector } from "react-redux";
import { getOrderHistory } from "../../redux/thunks/customerRecordThunk";
import { useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import Paydetail from "../Modals/Paydetail";
import OrderHistoryShimmer from "../Preloader/OrderHistoryShimmer";
import Pagination from "../Pagination";
import { encryptId } from "../../utils/urlCrypto";

const formatDate = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

const Order = ({ currentDate, customerId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pagination, isCustmerLoading } = useSelector(
    (state) => state.customerRecords,
  );
  const { current_page, total_pages, total_records } = pagination;
  const [page, setPage] = useState(1);
  const [orderDetails, setOrderDetails] = useState([]);
  const [Currency, setCurrency] = useState("");
  const [selectedCard, setSelectedCard] = useState(null);
  const [openpaydetail, setOpenpaydetails] = useState(false);

  const handleNavigate = (orderId) => {
    navigate(`/order-details/${encryptId(orderId)}`, {
      state: { fromCustomerOrder: true },
    });
  };

  useEffect(() => {
    if (!customerId || !currentDate) return;

    const startDate = formatDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
    );

    const endDate = formatDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0),
    );

    // console.log("The start date is :", startDate);
    // console.log("The end date is :", endDate);

    dispatch(
      getOrderHistory({
        service_provider_customer_id: customerId,
        page: page,
        start_date: startDate,
        end_date: endDate,
      }),
    )
      .unwrap()
      .then((res) => {
        setOrderDetails(res?.data?.orders || []);
        // console.log("The res of getting order history is :", res.data);
        setCurrency(res?.data?.currency_symbol);
      });
  }, [dispatch, customerId, currentDate, page]);

  const cardData = useMemo(() => {
    return orderDetails.map((item) => ({
      id: item.order_id,
      imgName: item.meal?.meal_cover_image,
      title: item.meal?.meal_name,
      amount: Number(item.total_amount).toFixed(2),
      orderImg: order,
      delImg: delivery,
      mealIcon:
        item.meal_timing === "dinner" ? (
          <GoMoon size={15} className="text-purple-800" />
        ) : (
          <GoSun size={15} className="text-[#FF6943]" />
        ),
      mealType: item.meal_timing,
      orderNum: item.quantity,
      delType: item.delivery_type,
      orderDate: item.order_date,
      orderStatus: item.status,
      paymentStatus: item.latest_payment?.payment_status,
      currencys: Currency,
      allData: item,
      checkIcon:
        item.latest_payment?.payment_status === "success" ||
        item.latest_payment?.payment_status === "paid" ? (
          <CheckCircle size={16} className="text-white" />
        ) : null,
    }));
  }, [orderDetails]);

  const handleCardClick = (card) => {
    // alert("Selected Card: " + JSON.stringify(card, null, 2));
    // console.log("Selected Card:", card);
    setSelectedCard(card);
    setOpenpaydetails(true);
  };

  const filteredCards = useMemo(() => {
    return cardData.filter((card) => {
      const d = new Date(card.orderDate);
      return (
        d.getMonth() === currentDate.getMonth() &&
        d.getFullYear() === currentDate.getFullYear()
      );
    });
  }, [cardData, currentDate]);

  const formatDateTime12 = (dateTime) => {
    if (!dateTime) return "";
    const date = new Date(dateTime.replace(" ", "T"));
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour12: true,
    });
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {isCustmerLoading ? (
          <OrderHistoryShimmer />
        ) : filteredCards.length === 0 ? (
          <p className="text-center text-gray-400 col-span-2 py-6">
            No orders in this month
          </p>
        ) : (
          filteredCards.map((data, index) => (
            <div key={index}>
              <Ordercards
                imgName={data.imgName}
                cardTitle={data.title || "Unknown Meal"}
                subTitle={`${data.currencys}${data.amount}`}
                orderDate={formatDateTime12(data.orderDate)}
                orderImg={data.orderImg}
                delImg={data.delImg}
                mealIcon={data.mealIcon}
                mealType={data.mealType}
                orderNum={data.orderNum}
                delType={data.delType}
                status={data.orderStatus}
                linkTO={() => handleNavigate(data.id)}
                checkIcon={data.checkIcon}
                clickIcon={() => handleCardClick(data.allData)}
              />
            </div>
          ))
        )}
      </div>

      {orderDetails.length > 0 && total_pages > 1 && (
        <Pagination
          current={current_page}
          total={total_pages}
          onPageChange={setPage}
        />
      )}

      {selectedCard && (
        <Paydetail
          open={openpaydetail}
          onClose={() => setOpenpaydetails(false)}
          card={selectedCard}
        />
      )}
    </>
  );
};

export default Order;
